import type { SelectChangeEvent } from "@mui/material";
import { MenuItem } from "@mui/material";
import Checkbox from "../../common/components/Checkbox";
import { Select } from "~/common/components/Select/Select";

interface DropdownWithMultiSelectProps {
  items: MultiselectAccountValue[];
  value: string[]; //ids or codes, values
  onChange: (e: SelectChangeEvent<string[]>) => void;
  onBlur?: () => void;
  label?: string;
  error?: boolean;
  helperLabel?: string;
  className?: string;
}

export type MultiselectAccountValue = {
  name: string;
  value: string;
  isChecked: boolean;
};

const DropdownWithMultiSelect = ({ items, value, onChange, ...rest }: DropdownWithMultiSelectProps) => {
  return (
    <Select
      variant={"outlined"}
      multiple
      fullWidth
      value={value}
      renderValue={(selected: unknown) =>
        (selected as string[]).map((v) => items.find((i) => i.value === v)?.name).join("; ")
      }
      onChange={onChange as (e: SelectChangeEvent<unknown>) => void}
      {...rest}
    >
      {items.map((item) => (
        <MenuItem key={item.value} value={item.value}>
          <Checkbox checked={value.includes(item.value)} className={"icon-margin"} />
          <span>{item.name}</span>
        </MenuItem>
      ))}
    </Select>
  );
};

export default DropdownWithMultiSelect;
